module.exports = __webpack_public_path__ + "assets/repair_required.600e525a.svg";